import { extract } from "@foundation/hydrate-model";

const get = <T>(object: object = {}, path = "", defaultValue?: T) => {
    return object === undefined
        ? defaultValue
        : extract(object, path) ?? defaultValue;
};

export default get;
